export default __webpack_public_path__ + "static/media/testimonial-3.8ca92296.png";